export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "contextWorker.3019f244.worker.js");
}
